import React from 'react';
import I18n from 'i18n-js';
import { isEppoExpEnabled, EppoSubjectTypes } from '@reverbdotcom/commons/src/eppo/eppoExperimentHelpers';
import { useEppoClient, useUser } from '@reverbdotcom/commons/src/user_hooks';
import eppoFlags from '@reverbdotcom/commons/src/eppoFlags';
import { Paths } from '../shared/url_helpers';

import { RCButton } from '@reverbdotcom/cadence/components';

export interface IProps {
  isOptedOutPhotoRelist: boolean;
  orderId: string;
}

export default function SellThisItemButton({ isOptedOutPhotoRelist, orderId }: IProps) {
  const eppoClient = useEppoClient();
  const user = useUser();

  const onClick = () => {
    const isInPhotoRelistExperiment = isEppoExpEnabled({
      eppoClient,
      user,
      flagKey: eppoFlags.PHOTO_RELISTING,
      subjectKey: user.id,
      subjectType: EppoSubjectTypes.USER_ID,
    });

    // If seller of original order has not opted out of photo relist AND current user is in the Eppo Experiment, redirect them to confirm condition page
    // Otherwise, redirect them to sell form as expected
    let redirectUrl;
    if (!isOptedOutPhotoRelist && isInPhotoRelistExperiment) {
      redirectUrl = Paths.confirmCondition.expand({ seed_id: orderId, seed_type: 'Order' });
    } else {
      redirectUrl = Paths.prefilledListingFromOrder.expand({ legacyOrderId: orderId });
    }
    window.location.href = redirectUrl;
  };

  return (
    <div className="width-100 mt-2 mobile-pb-2">
      <RCButton size="small" fullWidth onClick={onClick}>
        <span style={{ whiteSpace: 'normal' }}>
          {I18n.t('js.dashboard.buying.orders.sellThisItemButton.buttonText')}
        </span>
      </RCButton>
    </div>
  );
}
